import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'DMI',
  version: 2,
  label: 'Directional Movement Index',
  pane: 'sub',
  category: 'trend',
  series: 'normal',
  precision: 2,
  order: 70,
  inputs: [period('timeperiod', 14)],
  outputs: [line('plus_di', '+DI', COLOR.green), line('minus_di', '−DI', COLOR.red), line('adx', 'ADX', COLOR.orange)],
  talib: {
    functions: ['PLUS_DI', 'MINUS_DI', 'ADX'],
    expr: {
      plus_di: 'PLUS_DI(high, low, close, timeperiod={timeperiod})',
      minus_di: 'MINUS_DI(high, low, close, timeperiod={timeperiod})',
      adx: 'ADX(high, low, close, timeperiod={timeperiod})',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => 2 * timeperiod - 1,
}
export default def
